const clipperTesoreria = [
  {
    label: 'Caja',
    iconKey: 'tesoreria',
    items: [
      {
        label: 'Manejo de Cajas',
        to: '/tesoreria/caja/manejo-de-cajas',
        iconKey: 'tesoreria',
      },
      {
        label: 'Ingresos y Egresos de Caja',
        to: '/tesoreria/caja/ingresos-y-egresos-de-caja',
        iconKey: 'movimientos',
      },
    ],
  },
  {
    label: 'Cobranzas',
    iconKey: 'cobros',
    items: [
      {
        label: 'Seguimiento de Contrareembolsos Cobrados',
        to: '/tesoreria/cobranzas/seguimiento-de-contrareembolsos-cobrados',
        iconKey: 'historial',
      },
    ],
  },
  {
    label: 'Proveedores y Pagos',
    iconKey: 'pagos',
    items: [
      {
        label: 'Minutas de Pago',
        to: '/tesoreria/minutas-pago',
        iconKey: 'agenda',
      },
      {
        label: 'Cuentas a Pagar',
        to: '/tesoreria/cuentas-pagar',
        iconKey: 'pagos',
      },
    ],
  },
  {
    label: 'Bancos y Conciliación',
    iconKey: 'movimientos',
    items: [
      {
        label: 'Conciliación Bancaria',
        to: '/tesoreria/conciliaciones',
        iconKey: 'lista',
      },
    ],
  },
  {
    label: 'Contabilidad',
    iconKey: 'reportes',
    items: [
      {
        label: 'Asientos Contables',
        to: '/contabilidad/asientos',
        iconKey: 'lista',
      },
      {
        label: 'Informes Contables',
        to: '/contabilidad/reportes',
        iconKey: 'reportes',
      },
    ],
  },
  {
    label: 'Choferes',
    iconKey: 'tesoreria',
    items: [
      {
        label: 'Liquidaciones de Choferes',
        to: '/tesoreria/choferes/liquidaciones',
        iconKey: 'liquidaciones',
      },
    ],
  },
];

export default clipperTesoreria;
